"use client";

import { useEffect, useRef } from "react";

// https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/
export const useTimeout = (
  callback: () => void,
  delay: number | null | undefined
) => {
  const timeoutRef = useRef<number | undefined>();
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === "number") {
      timeoutRef.current = window.setTimeout(tick, delay);
      return () => window.clearTimeout(timeoutRef.current);
    }
  }, [delay]);
  return timeoutRef;
};
